import { type ChannelDTO, splitWikiTarget, type WikiSpaceDTO, type WikiTitleDTO } from "@justone/shared";

/** 위키 화면 주소: 공통 위키는 /wiki, 채널 위키는 채널의 위키 탭 */
export const wikiBase = (channelId: number | null) => (channelId === null ? "/wiki" : `/c/${channelId}/wiki`);
export const wikiPagePath = (channelId: number | null, pageId: number) => `${wikiBase(channelId)}/${pageId}`;

export interface ResolvedTarget {
  /** 공간이 아직 만들어지지 않은 채널이면 null (그 채널은 있다) */
  spaceId: number | null;
  channelId: number | null;
  title: string;
  pageId: number | null;
}

/**
 * [[대상]]을 페이지로: 같은 공간은 제목으로, 다른 공간은 [[#채널/제목]]·[[공통/제목]].
 * 없는 채널이면 null.
 */
export function resolveWikiTarget(target: string, from: WikiSpaceDTO, spaces: WikiSpaceDTO[], channels: ChannelDTO[], titles: WikiTitleDTO[]): ResolvedTarget | null {
  const { space, title } = splitWikiTarget(target);
  let channelId: number | null;
  let spaceId: number | null;
  if (space.kind === "same") {
    channelId = from.channelId;
    spaceId = from.id;
  } else if (space.kind === "company") {
    channelId = null;
    spaceId = spaces.find((s) => s.channelId === null)?.id ?? null;
  } else {
    const ch = channels.find((c) => c.name === space.name);
    if (!ch) return null;
    channelId = ch.id;
    spaceId = spaces.find((s) => s.channelId === ch.id)?.id ?? null;
  }
  const page = spaceId !== null ? titles.find((t) => t.spaceId === spaceId && t.title === title) : undefined;
  return { spaceId, channelId, title, pageId: page?.id ?? null };
}

/** 원격 커서·아바타 색 (ui의 아바타 색과 맞춘다) */
export const CURSOR_COLORS = ["#2e7d63", "#3b6ea8", "#9a5b2e", "#7a4f9a", "#a8434f", "#4f7f2a", "#2d7f8f", "#8a6d1f"];
export const cursorColor = (userId: number) => CURSOR_COLORS[userId % CURSOR_COLORS.length]!;
